import React from 'react';

const Select_yes_no = ({ checked, onChange, tabIndex = 0, id }) => {
  const handleClick = () => {
    onChange({ target: { checked: !checked } });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'y' || e.key === 'Y') {
      onChange({ target: { checked: true } });
    } else if (e.key === 'n' || e.key === 'N') {
      onChange({ target: { checked: false } });
    } else if (e.key === 'Enter') {
      onChange({ target: { checked: !checked } });
    }
  };

  return (
    <div className='bold'
      tabIndex={tabIndex}
      id={id}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      style={{
        width: '60px',
        userSelect: 'none',
        textAlign: 'center',
        cursor: 'pointer',
        border: '1px solid #ccc',
        padding: '5px',
        borderRadius: '4px',
        backgroundColor: checked ? '#d1e7dd' : '#f8d7da', // green for yes, red for no
        color: checked ? '#0f5132' : '#842029',
      }}
    >
      {checked ? 'Yes' : 'No'}
    </div>
  );
};

export default Select_yes_no;
